import styled from 'styled-components';
import { Typography } from '../../display/Typography';

import { InputTextArea } from '../../inputs/InputTextArea';

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.xxl}rem;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxl}rem;
`;

export const ContainerBasicInfo = styled.div``;

export const ContainerDescription = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  gap: 3.3rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.l}rem;
  }
`;

export const InputsContainerRow = styled.div``;

export const InputsContainerDescription = styled(InputsContainer)`
  max-width: 105.1rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
  }
`;

export const SubContainerDescription = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const Title = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spaces.l}rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.M};
  }
`;

export const LocationInputGroupOrder = styled.div`
  display: flex;
  gap: 3.3rem 1rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const LocationInputGroupCommunication = styled.div`
  display: flex;
  gap: 3.3rem 1rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const ConcessionWrapper = styled.div`
  display: flex;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex: 0 0 auto;
    max-width: 10rem;
    min-width: 7rem;
  }
`;

export const RoadInputSubGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-basis: 100%;
    width: 100%;
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const PkInputContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.l}rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const InputTextAreaStyled = styled(InputTextArea)`
  flex-basis: 100%;
  margin-top: ${({ theme }) => theme.spaces.l}rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.s}rem;
  justify-content: flex-end;
`;
